import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { SettingsContext } from '../contexts/SettingsContext';

interface WaitTimeResource {
  expectedStart: string;
  id: number;
  waitTime: number;
}

const makeWaitTimeForServiceKey = (
  locationId?: number | string,
  serviceId?: number | string,
) => ['wait-time-for-service', locationId, serviceId];

export const useWaitTimeForService = (
  locationId?: number | string,
  serviceId?: number | string,
  options: { enabled?: boolean } = {},
) => {
  const enabled = typeof options.enabled === 'boolean' ? options.enabled : true;
  const { showCallbackWaitTime } = useContext(SettingsContext);

  if (typeof serviceId === 'string') {
    serviceId = parseInt(serviceId, 10);
  }

  return useQuery({
    enabled: enabled && showCallbackWaitTime && !!(locationId && serviceId),
    queryKey: makeWaitTimeForServiceKey(locationId, serviceId),
    queryFn: async () => {
      const url = `/api/v2/open/queue-appointments-services/${locationId}?meeting_method=1&service=${serviceId}`;
      const response = await fetch(url);
      const data = await response.json();
      const waitTimes: WaitTimeResource[] = data?.[1] ?? [];

      return (
        waitTimes.find((waitTime) => waitTime?.id === serviceId)
          ?.expectedStart ?? null
      );
    },
    staleTime: 1000 * 60, // 1 minute
  });
};
